export default {
      id: "direction_track-usage",
      viewBox: "0 0 428 340",
      url: __webpack_public_path__ + "img/icons.svg#direction_track",
      toString: function () {
        return this.url;
      }
    }